// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71717L2 5.9255V21.4999L7.5 19.2326V2.71717Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9095L12.2987 20.5623C11.4811 19.4168 11 18.0145 11 16.4999C11 13.9089 12.4077 11.6467 14.5 10.4364V5.09027L9.5 2.13745V18.9095Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2.49987V10.7546C20.8662 9.9637 19.4872 9.49988 18 9.49988C17.4851 9.49988 16.9832 9.55547 16.5 9.66097V4.76719L22 2.49987Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.211 13.9568L18.0002 10.7308L15.7893 13.9568L12.0381 15.0625L14.4229 18.1621L14.3154 22.0714L18.0002 20.7611L21.6849 22.0714L21.5774 18.1621L23.9623 15.0625L20.211 13.9568Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-collection-filled')
export default class MapCollectionFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-collection-filled',
    }
  }
}
